module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_cuad_4.809c982d.png";